import { Controller } from "@hotwired/stimulus"

// TODO: unite with navigation_controller.js
// Connects to data-controller="documents--sidebar"
export default class extends Controller {
  static targets = ["sidebar"]

  connect() {
    this.#toggleOffcanvas()
    // remove page__sidebar--hidden class after initial load, without it the offcanvas could be visible for a short time
    this.sidebarTarget.classList.remove("page__sidebar--hidden")

    window.addEventListener("resize", this.#handleResize)
    // document.addEventListener("turbo:frame-missing", this.#handleTurboFrameMissing);
  }

  disconnect() {
    window.removeEventListener("resize", this.#handleResize)
    // document.removeEventListener("turbo:frame-missing", this.#handleTurboFrameMissing);
  }

  #toggleOffcanvas = () => {
    if (this.#isMobileDevice()) {
      this.sidebarTarget.classList.add("offcanvas", "offcanvas-end")
    } else {
      this.sidebarTarget.classList.remove("offcanvas", "offcanvas-end")
    }
  }

  #isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    const isMobileUserAgent = /android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
    const isMobileWindowSize = window.innerWidth <= 992

    return isMobileUserAgent || isMobileWindowSize
  }

  #handleTurboFrameMissing(event) {
    const {
      detail: { response, visit }
    } = event
    event.preventDefault()
    visit(response.url)
  }

  #handleResize = () => {
    this.#toggleOffcanvas()
  }
}
